import css from '../../../utils/css';

export default css`
  :host {
    --muted-cta-color: color-mix(in lch, var(--widget-cta-color) 80%, #777);
  }

  #root {
    [class*='CardWrapper_'] {
      overflow: hidden; /* fix border radius overflow issue */
      background: var(--widget-background-color); /* main bg */
      border-radius: var(--widget-border-radius, 5px);
      --mc-button-border-radius: var(--widget-cta-border-radius);

      border-color: var(--widget-accent-background-color);
      --widget-cta-text-color: var(--widget-text-color);
      --ogm-font-family-2: var(--widget-font-family);
      --oc-font-family: var(--widget-font-family);
      --mc-button-background: var(--widget-cta-background-color);
      --mc-button-background-hover: var(--widget-cta-hover-color);
      --cxy-color-interactive-secondary-subtle: var(--widget-text-color);
    }

    /* super header colours */
    [class*='AccordionHeader_'] {
      background-color: var(--widget-accent-background-color);
      --cxy-color-text-neutral-base: var(--widget-accent-text-color);
      border-radius: 0;
      border-bottom: 0;
    }

    /* header text color */
    [class*='GroupWrapper_'] [class*='TitleWrapper_'] {
      --cxy-color-text-neutral-base: var(--widget-accent-text-color);
    }

    /* remove extraneous border */
    [class*='GroupWrapper_'] [class*='TitleWrapper_'] {
      border-top: none;
      border-bottom: none;
    }
    [class*='GroupWrapper_'] [class*='RowWrapper_']:last-child {
      border-bottom: none;
    }
    [class*='GroupWrapper_'] [class*='RowWrapper_']:last-child {
      border-bottom: none;
    }

    /* cta */
    button[class*='bestOddsButton_'] {
      --cxy-color-text-neutral-base: var(--widget-cta-color);
      transition-duration: 200ms;

      [class*='OddsTextWrapper_'] {
        color: inherit;
      }

      [class*='LineWrapper_'] {
        color: var(--muted-cta-color, inherit);
        white-space: nowrap;
      }
    }
  }
`;
